import { ReactElement } from 'react';
import { RadioGroup } from '@headlessui/react';
import classNames from 'classnames';

import { AgendaSlot } from '../utils/spaceAgenda';

type Props = {
  slots: AgendaSlot[];
  value: string | null;
  onChange: (id: string) => void;
  isSpanish?: boolean;
};

export default function AgendaSlotPicker({
  slots,
  value,
  onChange,
  isSpanish = true,
}: Props): ReactElement {
  const selectable = slots.filter((s) => s.isSelectable);

  if (!slots.length || !selectable.length) {
    return (
      <p className="text-[13px] text-gray-500">
        {isSpanish
          ? 'No quedan horarios disponibles para este día.'
          : 'No time slots left for this day.'}
      </p>
    );
  }

  return (
    <RadioGroup value={value ?? ''} onChange={onChange}>
      {/* Cápsulas de horario con el MISMO lenguaje visual que fechas/tipo de entrada: grid que
          hace wrap (varias por fila en desktop, menos en mobile según el ancho); SIN periodos,
          SIN acordeones y SIN scroll interno (la tarjeta crece). Cada cápsula muestra el label
          REAL completo del slot ("08:00 - 08:30"), no solo la hora de inicio. */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {selectable.map((slot) => (
          <RadioGroup.Option
            key={slot.id}
            value={slot.id}
            className="rounded-[16px] focus:outline-none focus-visible:ring-2 focus-visible:ring-tikipal-orange/40"
          >
            {({ checked }) => (
              <div
                title={slot.label}
                className={classNames(
                  'px-2 py-2.5 rounded-[16px] text-center text-[13px] tabular-nums whitespace-nowrap border transition-colors cursor-pointer',
                  checked
                    ? // Seleccionado: naranja MUY suave + borde naranja sutil + texto oscuro
                      // (nunca naranja sólido ni sombra fuerte — ese rol es del CTA).
                      'bg-tikipal-orange/10 border-tikipal-orange/40 text-gray-900'
                    : // No seleccionado: neutro/translúcido + borde gris sutil + texto oscuro.
                      'bg-white/40 border-gray-200 text-gray-800 hover:border-gray-300'
                )}
              >
                {slot.label}
              </div>
            )}
          </RadioGroup.Option>
        ))}
      </div>
    </RadioGroup>
  );
}
